import React, {useEffect, useState} from "react";
import Header from "../components/header/Header";
import Greeting from "./greeting/Greeting";
import Skills from "./skills/Skills";
import StackProgress from "./skillProgress/skillProgress";
import WorkExperience from "./workExperience/WorkExperience";
import StartupProject from "./StartupProjects/StartupProject";
import Footer from "../components/footer/Footer";
import Education from "./education/Education";
import ScrollToTopButton from "./topbutton/Top";
import Profile from "./profile/Profile";
import SplashScreen from "./splashScreen/SplashScreen";
import AnimatedBackground from "../components/animatedBackground/AnimatedBackground";
import ScrollProgress from "../components/scrollProgress/ScrollProgress";
import CursorGlow from "../components/cursorGlow/CursorGlow";
import MobileTouchFX from "../components/mobileTouchFX/MobileTouchFX";
import MobileTouchAura from "../components/mobileTouchAura/MobileTouchAura";
import {splashScreen} from "../portfolio";
import {StyleProvider} from "../contexts/StyleContext";
import {useLocalStorage} from "../hooks/useLocalStorage";
import "./Main.scss";

const Main = () => {
  const [isDark, setIsDark] = useLocalStorage("isDark", true);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] =
    useState(true);

  useEffect(() => {
    if (splashScreen.enabled) {
      const splashTimer = setTimeout(
        () => setIsShowingSplashAnimation(false),
        splashScreen.duration
      );
      return () => {
        clearTimeout(splashTimer);
      };
    } else {
      setIsShowingSplashAnimation(false);
    }
  }, []);

  const showApp = !(isShowingSplashAnimation && splashScreen.enabled);

  const changeTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className={isDark ? "dark-mode app-root" : "app-root"}>
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        {!showApp ? (
          <SplashScreen />
        ) : (
          <>
            <AnimatedBackground isDark={isDark} />
            <div className="app-content">
              <CursorGlow enabled={showApp} />
              <MobileTouchAura enabled={showApp} />
              <MobileTouchFX enabled={showApp} />
              <ScrollProgress />
              <Header />
              <Greeting />
              <Skills />
              <StackProgress />
              <Education />
              <WorkExperience />
              <StartupProject />
              <Profile />
              <Footer />
              <ScrollToTopButton />
            </div>
          </>
        )}
      </StyleProvider>
    </div>
  );
};

export default Main;
